import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { TwitterUser } from '../types/common';
import './LandingPage.css';

interface LandingPageProps {
  twitterUser: TwitterUser | null;
  setTwitterUser: (user: TwitterUser | null) => void;
}

function LandingPage({ twitterUser, setTwitterUser }: LandingPageProps) {
  const urlParams = new URLSearchParams(window.location.search);
  const showTestLevels = urlParams.get('showTestLevels') === 'true';

  useEffect(() => {
    document.title = 'mfers arcade';
  }, []);

  return (
    <div className="landingPageContainer" data-testid="landing-page">
      <div className="games-container" data-testid="games-container">
        <div className="game-item" data-testid="game-item-alien2048">
          <Link to="/alien2048/" data-testid="link-alien2048">
            <img src="/images/mfersbeheaded/fullbody/alien.png" alt="Alien 2048" />
            <p>Alien 2048</p>
          </Link>
        </div>
        <div className="game-item" data-testid="game-item-mfersbeheaded">
          <Link to="/mfersbeheaded/" data-testid="link-mfersbeheaded">
            <img src="/images/mfersbeheaded-thumb.png" alt="Mfers Beheaded" />
            <p>Mfers Beheaded</p>
          </Link>
        </div>
        {/* Hidden from main page - still accessible via direct link /mferchess/
        <div className="game-item" data-testid="game-item-mferchess">
          <Link to="/mferchess/" data-testid="link-mferchess">
            <img src="/images/mferchess-thumb.png" alt="Chess" />
            <p>Mfer Chess</p>
          </Link>
        </div> */}
        {/* Hidden from main page - still accessible via direct link
        <div className="game-item">
          <Link to="/flappymfer/">
            <img src="/images/flappymfer.svg" alt="Flappy Mfer" />
            <p>Flappy Mfer</p>
          </Link>
        </div> */}
        {/* <div className="game-item">
          <Link to="/connect4/">
            <img src="/images/connect4.png" alt="Connect 4" />
          </Link>
          <p>Hoodies vs Top Hats (Connect 4)</p>
        </div> */}
        {/* <div className="game-item">
          <img onClick={createMferCastleGame} src="/images/mfercastle.png" alt="Mfers Castle" />
          <p>🚧 Mfers Castle 🚧</p>
        </div> */}
        {/* <div className="game-item">
          <Link to="/mferfight/">
            <img src="/images/mferchess.png" alt="Fight" />
          </Link>
          <p>Mfer Fighting</p>
        </div> */}
        {showTestLevels && (
          <div className="game-item" data-testid="game-item-larvalegends">
            <Link to="/larvalegends/" data-testid="link-larvalegends">
              <img src="/images/mferchess.png" alt="Larva Legends" />
              <p>🚧 Larva Legends 🚧</p>
            </Link>
          </div>
        )
        }
      </div>
    </div>
  );
}

export default LandingPage;